import { useState, useEffect } from "react";
import api from "../../utils/api";

// Scans that reached a dead end: unknown short-link IDs, unknown or malformed GTINs
const NotFoundTable = ({ queryParams }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/api/analytics/not-found?${queryParams}`).then((r) => setRows(r.data)).catch(console.error).finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) return <div className="text-center py-4"><div className="spinner-border spinner-border-sm" role="status" /></div>;
  if (rows.length === 0) return <p className="text-muted text-center mb-0">No dead-end scans in the selected date range.</p>;

  const total = rows.reduce((s, r) => s + r.count, 0);
  const fmt = (iso) => (iso ? iso.slice(0, 16).replace("T", " ") : "");
  return (
    <div>
      <p className="text-muted small mb-2">{total.toLocaleString()} scans hit a code the system could not resolve. Repeated values usually mean a misprint or a retired short link still in market.</p>
      <div style={{ maxHeight: "300px", overflow: "auto" }}>
        <table className="table table-sm table-hover" style={{ fontSize: "12px" }}>
          <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
            <tr><th>Scanned value</th><th>Kind</th><th style={{ textAlign: "right" }}>Scans</th><th>First seen (UTC)</th><th>Last seen (UTC)</th><th>Domain</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.scanned}>
                <td style={{ fontFamily: "monospace", wordBreak: "break-all", maxWidth: 260 }}>{r.scanned || "(empty)"}</td>
                <td><span className={`badge ${r.kind.startsWith("GS1") ? "bg-success" : "bg-secondary"}`} style={{ fontSize: "10px" }}>{r.kind}</span></td>
                <td style={{ textAlign: "right" }}>{r.count.toLocaleString()}</td>
                <td style={{ whiteSpace: "nowrap" }}>{fmt(r.firstSeen)}</td>
                <td style={{ whiteSpace: "nowrap" }}>{fmt(r.lastSeen)}</td>
                <td>{r.domains.join(", ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NotFoundTable;
